import { AxiosResponse } from "axios";
import { APIClient } from "./axiosClient";
import { PaginationResponse, ResponseData } from "./types/_public";
import { IFacility } from "./types/_facility";

const api = new APIClient();

const path = "/bars/reviews";

const barReviewApi = {
  getBarReviews(params: any): any {
    const url = `${path}`;
    return api.get(url, params);
  },

  getBarReviewDetail(
    id: string | number,
    params: any = {}
  ): Promise<AxiosResponse<ResponseData<IFacility>, any>> {
    const url = `${path}/${id}`;
    return api.get(url, params);
  },

  deleteBarReview(id: any) {
    return api.delete(`${path}/${id}`);
  },

  postBarReview(
    dataForm: any
  ): Promise<AxiosResponse<ResponseData<IFacility>, any>> {
    const url = `${path}`;
    return api.post(url, dataForm);
  },

  putBarReview(
    id: string | number,
    dataForm: any
  ): Promise<AxiosResponse<ResponseData<IFacility>, any>> {
    const url = `${path}/${id}`;
    return api.put(url, dataForm);
  },
};

export default barReviewApi;
